module.exports = __webpack_public_path__ + "static/media/touch_tablet.75a00a33.png";